import { render, staticRenderFns } from "./Descontos.vue?vue&type=template&id=14baf01e&scoped=true&"
import script from "./Descontos.vue?vue&type=script&lang=js&"
export * from "./Descontos.vue?vue&type=script&lang=js&"
import style0 from "./Descontos.vue?vue&type=style&index=0&id=14baf01e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14baf01e",
  null
  
)

export default component.exports